export default [
  {
    path:'/admin/integral/integral_list',
    name:'integralList',
    component:()=>import('../views/integral/list'),
    meta:{
      title:'积分商城'
    }
  },{
    path:'/admin/integral/edit',
    name:'edit',
    component:()=>import('../views/integral/edit'),
    meta:{
      title:'新增-修改积分商品'
    }
  },{
    path:'/admin/integral/order',
    name:'integralOrder',
    component:()=>import('../views/integral/order'),
    meta:{
      title:'积分订单'
    }
  },
  {
    path:'/admin/integral/set_up',
    name:'set_up',
    component:()=>import('../views/integral/set_up'),
    meta:{
      title:'积分配置'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/integral.js